import { render, staticRenderFns } from "./CompanyThumbnail.vue?vue&type=template&id=13fa3a56"
import script from "./CompanyThumbnail.vue?vue&type=script&lang=js"
export * from "./CompanyThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports